/* eslint-disable react/display-name */
import { useEffect, useState, useRef } from "react";
import React from "react";
import Link from "next/link";
import Image from "next/image";
import {
  Container,
  Row,
  Col,
  Form,
  InputGroup,
  Button,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import Select from "react-select";
import { toast } from "react-toastify";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  setName,
  set_Selected_languages,
  set_Selected_languages_symp,
  setFilter,
  setEmptyFilter,
} from "@/redux/features/healer/healersPageSlice.js";
import Layout from "@/components/layout";
import styles from "@/styles/HealerListing.module.css";
import { healerServices } from "@/services/healerServices";
import audioSessionImage from "../../../public/images/audio-session.svg";
import videoSessionImage from "../../../public/images/video-session.svg";
import inPersonSessionImage from "../../../public/images/person-person.svg";
import dummyHealerImage from "../../../public/images/dummy-user.svg";
import {
  setSelectedAppointment,
  setSelectedBookingType,
  setSelectedDate,
  setDateSliderPayload,
  setSelectedSlot,
} from "@/redux/features/bookAppointmentSlice";
import styless from "@/styles/PageLoader.module.css";
import Head from "next/head";
import Modalityfilter from "@/components/modalityFilter";
import Symptomsfilter from "@/components/symptomsFilter";

const HealerListing = (props) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { filters, name, selected_languages, selected_languages_symp } =
    useSelector((state) => state.healersPage);
  console.log(filters, "filters");
  const [modalities, setModalities] = useState([]);
  const [symptoms, setSymptoms] = useState([]);
  const [bookingTypes, setBookingTypes] = useState([]);
  const [states, setStates] = useState([]);
  const [healers, setHealers] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [filterApplied, setFilterApplied] = useState(false);
  const [listIndex, setListIndex] = useState(1);
  const [setFilterPop, setshowfilter] = useState(false);
  const [apiLoader, setApiLoader] = useState(true);
  const [healersMeta, setHealersMeta] = useState(props?.healersMeta ?? {});
  const [screenSize, setScreenSize] = useState();
  const [searchBar, setSearchBar] = useState(false);
  const [cancelBtn, setCancelBtn] = useState("");
  const [categoryIcon, setCategoryIcon] = useState(true);
  //const [selected_languages, set_Selected_languages] = useState([]);
  //const [selected_languages_symp, set_Selected_languages_symp] = useState([]);
  const [showSideButton, setShowSideButton] = useState(false);
  const firstSectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!firstSectionRef.current) return;

      const sectionTop = firstSectionRef.current.getBoundingClientRect().bottom;

      setShowSideButton(sectionTop < 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const onChangeBookingType = async (event) => {
    const selectedValue = parseInt(event.target.value);
    dispatch(setFilter({ ...filters, bookingTypes: [selectedValue] }));
  };

  useEffect(() => {
    setScreenSize(window.innerWidth);
  }, []);

  const customStyles = {
    option: (base, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...base,
        backgroundColor: isFocused ? "#002A0F" : "#fff",
        color: isFocused ? "#fff" : "#666",
        fontSize: "12px",
        fontWeight: "600",
        width: "135px",
      };
    },
  };

  const onChangeRatings = async (event) => {
    const values = [...filters.ratings];
    const index = values.findIndex((i) => i == event.target.value);
    if (event.target.checked && index == -1) {
      values.push(event.target.value);
    } else {
      values.splice(index, 1);
    }
    dispatch(setFilter({ ...filters, ratings: values }));
  };

  const clearFilter = () => {
    dispatch(setName(""));
    dispatch(setEmptyFilter());
    setListIndex(1);
  };

  useEffect(() => {
    const resetFilters = () => {
      if (window.location.pathname != router.pathname && filterApplied) {
        dispatch(setName(""));
        dispatch(setEmptyFilter());
        setFilterApplied(false);
      }
    };

    router.events.on("routeChangeComplete", () => resetFilters());
    return () => {
      router.events.off("routeChangeComplete", () => resetFilters());
    };
  }, [router.events, filterApplied]);

  useEffect(() => {
    if (props?.modalities) {
      setModalities(props?.modalities);
    }
    if (props?.symptoms) {
      setSymptoms(props?.symptoms);
    }
    if (props?.states) {
      setStates(props?.states);
    }
    if (props?.bookingTypes) {
      setBookingTypes(props?.bookingTypes);
    }
  }, []);

  const fetchHealers = async (scroll = null) => {
    //if infinite scrolling then scroll will be true and will run with filters
    //else any filter is applied then scroll is null filter will be applied previos data will be removed and index will be reset to 1
    try {
      let index;

      if (scroll) {
        index = listIndex + 1;
      } else {
        setHealers([]);
        index = 1;
      }

      //api pagination index for infinite scrolling
      setListIndex(index);

      const payload = {
        healer_name: filters?.name,
        modalities: filters?.modalities?.map((i) => i?.value) ?? [],
        session_types: filters?.bookingTypes ?? [],
        ratings: filters?.ratings ?? [],
        state_id: filters?.state?.value,
        city: filters?.city,
        symptoms: filters?.symptoms?.map((i) => i?.value) ?? [],
        sort: filters?.sorting,
        page: index,
        is_free: filters?.is_free,
      };

      const res = await healerServices.getHealers(payload);
      setApiLoader(false);
      if (res.status) {
        if (res.data.length > 0) {
          setHealers((prevHealers) => [
            ...new Map(
              [...prevHealers, ...res.data].map((item) => [item["id"], item])
            ).values(),
          ]);
          setHasMore(true);
          dispatch(setSelectedAppointment(null));
          dispatch(setSelectedBookingType(null));
          dispatch(setSelectedDate(null));
          dispatch(setDateSliderPayload(null));
          dispatch(setSelectedSlot(null));
        } else {
          setHasMore(false);
        }
      } else {
        toast.error(res.message, {
          autoClose: 5000,
        });
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching healers:", error);
      setHasMore(false);
    }
  };

  useEffect(() => {
    const { bookingTypes, ratings, state, city, sorting, name, is_free } =
      filters;
    setFilterApplied(
      filters.modalities.length > 0 ||
        bookingTypes.length > 0 ||
        ratings.length > 0 ||
        (state && state.value) ||
        city ||
        filters.symptoms.length > 0 ||
        (sorting && sorting.value) ||
        name !== "" ||
        is_free == true ||
        is_free == false
    );
    //
    console.log("modalities", "filters", modalities, filters);
    if (modalities.length) {
      fetchHealers();
    }
  }, [dispatch, modalities, filters]);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      dispatch(setFilter({ ...filters, name }));
    }
  };

  return (
    <>
      <Head>
        <title>{healersMeta?.meta?.og_title}</title>
        <meta name="title" content={healersMeta?.meta?.meta_title}></meta>
        <meta
          name="description"
          content={healersMeta?.meta?.meta_description}
        ></meta>
        <meta name="keywords" content={healersMeta?.meta?.meta_keywords}></meta>
        <meta property="og:type" content="website"></meta>
        <meta property="og:title" content={healersMeta?.meta?.og_title}></meta>
        <meta
          property="og:description"
          content={healersMeta?.meta?.meta_description}
        ></meta>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={healersMeta?.meta?.meta_title} />
        <meta
          name="twitter:description"
          content={healersMeta?.meta?.meta_description}
        />
        <meta name="twitter:image" content={healersMeta?.meta?.og_image} />
        <meta property="og:url" content="https://www.zenkify.com/healers" />
        <meta property="og:site_name" content="Zenkify" />
        <meta property="og:image:alt" content="Relki Healing Services" />
        <meta property="og:image" content={healersMeta?.meta?.og_image}></meta>
        <link rel="canonical" href="https://www.zenkify.com/healers"></link>
      </Head>
      <>
        <section
          className={styles["section-banner"] + " banner-hide-banner"}
          style={{ background: "url(/images/healerlisting-banner.jpg)" }}
          ref={firstSectionRef}
        >
          <Container>
            <Row>
              <Col md={8} className="m-auto">
                <div className={styles["inner-content"]}>
                  <h1 className={styles["banner-title"]}>
                    Our Healers Listing
                  </h1>
                  <h2>
                    Our certified healers are available to give you healing
                    sessions which can help to improve mental wellness,
                    emotional well-being, self help, trauma healing and many
                    more benefits. You can schedule a Video/Audio or an In
                    person session whichever works best for you.
                  </h2>
                  <ul className={styles["list"]}>
                    <li>
                      <div className={styles["icon"]}>
                        <Image src={videoSessionImage} alt="Video Session" />
                      </div>
                      <h6>Video Session</h6>
                    </li>
                    <li>
                      <div className={styles["icon"]}>
                        <Image src={audioSessionImage} alt="Audio Session" />
                      </div>
                      <h6>Audio Session</h6>
                    </li>
                    <li>
                      <div className={styles["icon"]}>
                        <Image src={inPersonSessionImage} alt="In Person" />
                      </div>
                      <h6>In Person</h6>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        {apiLoader ? (
          <div className={styless.overlay}>
            <div className={styless.loader}>
              <Image
                width={151}
                height={159}
                src="/images/logo.svg"
                alt="Zenkify Logo"
              />
            </div>
          </div>
        ) : (
          <section className="listing-section">
            <Container>
              <Row>
                <div
                  className={`leftFilerOption ${
                    setFilterPop ? "show" : " "
                  } pe-lg-4`}
                >
                  <div
                    className="sidebar-filter"
                    style={
                      screenSize > 768 ? { display: "none" } : { display: "" }
                    }
                  >
                    <Row>
                      <Col lg={6}>
                        <h3 className="filter-title">Filter</h3>
                      </Col>
                      <Col lg={6} className="float-right text-right">
                        {filterApplied ? (
                          <Button
                            type="button"
                            className="theme-btn clearall-filter"
                            onClick={() => clearFilter()}
                          >
                            Clear All Filters <i className="fa fa-times"></i>
                          </Button>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                    {/* <div className="session-type">
                      <h4 className="filter-text">
                        Healers Offering Free Intro Calls
                      </h4>
                      <div className="form-check d-flex">
                        <Form.Check
                          type="radio"
                          name="callOption"
                          value="freeCall"
                          onChange={() => {
                            dispatch(setFilter({ ...filters, is_free: true }));
                          }}
                          checked={filters.is_free === true}
                          id="freeCall" // Set the id here
                        />
                        <Form.Label
                          className="form-check-label"
                          htmlFor="freeCall" // Make sure the `for` matches the id of the radio button
                        >
                          Free Call
                        </Form.Label>
                      </div>

                      <div className="form-check d-flex">
                        <Form.Check
                          type="radio"
                          name="callOption"
                          value="paidCall"
                          onChange={() => {
                            dispatch(setFilter({ ...filters, is_free: false }));
                          }}
                          checked={filters.is_free === false}
                          id="paidCall" // Set the id here
                        />
                        <Form.Label
                          className="form-check-label"
                          htmlFor="paidCall" // Make sure the `for` matches the id of the radio button
                        >
                          Paid Call
                        </Form.Label>
                      </div>
                    </div> */}
                    <div className="free-intro-wrapper">
                      <button type="button"
                        className={`new-dropdown-btn free-intro-btn ${filters.is_free === true ? "active" :""}`}
                        onClick={()=>{
                          dispatch(setFilter({...filters,is_free : true}));
                        }}>
                       Free Intro Calls
                   </button>
                    </div>
                  

                    <div className="modalities-select mobalitiesinput">
                      <h4 className="filter-text">Modalities</h4>
                      <InputGroup className="filter-select-group">
                        <span className="input-group-icon">
                          <i className="ri-list-check"></i>
                        </span>
                        <Select
                          className="w-100 custom-multi-select"
                          name="modalities"
                          id="modalities"
                          instanceId={"modalities"}
                          isMulti
                          isSearchable={screenSize > 991 ? true : searchBar}
                          onMenuClose={() => {
                            setSearchBar(!searchBar);
                          }}
                          value={filters.modalities}
                          options={modalities}
                          onChange={(value) =>
                            dispatch(
                              setFilter({ ...filters, modalities: value })
                            )
                          }
                          placeholder={"Select Modalities"}
                        />
                      </InputGroup>
                    </div>
                    <div className="modalities-select">
                      <h4 className="filter-text">Symptoms</h4>
                      <InputGroup className="filter-select-group">
                        <span className="input-group-icon">
                          <i className="ri-mist-line"></i>
                        </span>
                        <Select
                          className="w-100 custom-multi-select"
                          name="symptoms"
                          id="symptoms"
                          instanceId={"symptoms"}
                          isMulti
                          isSearchable={screenSize > 991 ? true : searchBar}
                          onMenuClose={() => {
                            setSearchBar(!searchBar);
                          }}
                          value={filters.symptoms}
                          options={symptoms}
                          onChange={(value) =>
                            dispatch(setFilter({ ...filters, symptoms: value }))
                          }
                          placeholder={"Select Modalities"}
                        />
                      </InputGroup>
                    </div>
                    <div className="session-type">
                      <h4 className="filter-text">Session Type</h4>
                      {bookingTypes?.map((type, index) => (
                        <div className="form-check d-flex" key={index}>
                          <Form.Check
                            onChange={(e) => {
                              onChangeBookingType(e);
                            }}
                            type="radio"
                            name="booking-type"
                            value={type.id}
                            checked={filters?.bookingTypes.some(
                              (item) => item == type.id
                            )}
                            id={"booking-type-" + index}
                          />
                          <Form.Label
                            className="form-check-label"
                            for={`default-${type.id}`}
                          >
                            {type.name}
                          </Form.Label>
                        </div>
                      ))}
                    </div>
                    <div className="filtar-rating">
                      <h4 className="filter-text">Rating</h4>
                      {[...Array(5).keys()].reverse().map((e, i) => (
                        <>
                          <div className="form-check mb-2" key={i}>
                            <Form.Check
                              type="checkbox"
                              name="rating"
                              value={e + 1}
                              onChange={(el) => {
                                onChangeRatings(el);
                              }}
                              checked={filters.ratings.includes(
                                (e + 1).toString()
                              )}
                              id={`rating-${e + 1}`}
                            />
                            <Form.Label
                              className="form-check-label"
                              htmlFor={`rating-${e + 1}`}
                            >
                              <span>
                                {[...Array(5).keys()].reverse().map((f, j) => (
                                  <>
                                    <i
                                      key={j}
                                      className={`ri-star-fill ${
                                        e + 1 >= f + 1 ? "star-fill" : ""
                                      }`}
                                    ></i>
                                  </>
                                ))}
                              </span>
                            </Form.Label>
                          </div>
                        </>
                      ))}
                    </div>
                    <div className="select-location">
                      <h4 className="filter-text">State</h4>
                      <InputGroup className="filter-select-group">
                        <span className="input-group-icon">
                          <i className="ri-list-check"></i>
                        </span>
                        <Select
                          className="w-100 locationSelect"
                          name="state"
                          id="state"
                          instanceId={"state"}
                          isSearchable={screenSize > 991 ? true : searchBar}
                          onMenuClose={() => {
                            setSearchBar(!searchBar);
                          }}
                          value={filters.state}
                          options={states}
                          onChange={(value) =>
                            dispatch(setFilter({ ...filters, state: value }))
                          }
                          placeholder={"Select State"}
                        />
                      </InputGroup>
                      <InputGroup className="mt-3 cityinput">
                        <span className="input-group-icon">
                          <i className="ri-list-check"></i>
                        </span>
                        <Form.Control
                          className="w-100 CitySelectInput"
                          type="text"
                          name="city"
                          placeholder="Enter city here..."
                          value={filters.city}
                          onInput={(e) =>
                            dispatch(
                              setFilter({ ...filters, city: e.target.value })
                            )
                          }
                        />
                      </InputGroup>
                    </div>
                    <div className="filter-mobile-fixed">
                      <div className="button-inner">
                        {filterApplied ? (
                          <Button
                            type="button"
                            className="bttn"
                            onClick={() => clearFilter()}
                          >
                            Clear All
                          </Button>
                        ) : (
                          <Button
                            type="button"
                            className="bttn"
                            disabled
                            onClick={() => clearFilter()}
                          >
                            Clear All
                          </Button>
                        )}
                        <Button
                          type="button"
                          className="close-btn bttn"
                          onClick={() => setshowfilter(false)}
                        >
                          Close
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="rightHelearListing">
                  <Row className="filter-header align-items-center row gap-4">
                    <Col
                      xxl={2}
                      className="mobileSearchForm col-xl-12 col-xxl-2 col-lg-12"
                    >
                      <div className="search-bar">
                        <InputGroup>
                          <span className="input-group-text">
                            <i className="ri-search-line"></i>
                          </span>
                          <Form.Control
                            type="text"
                            className="form-control"
                            placeholder="Search"
                            value={name}
                            onInput={(e) => dispatch(setName(e.target.value))}
                            onKeyDown={(e) => {
                              handleKeyPress(e);
                            }}
                          />
                          <Button
                            className="search-bttn"
                            onClick={() =>
                              dispatch(setFilter({ ...filters, name }))
                            }
                          >
                            <i className="ri-search-line"></i>
                          </Button>
                        </InputGroup>
                      </div>
                    </Col>
                    <Col xxl={12} className="col-xl-12">
                      <div
                        className={`filterhealer-top justify-content-xxl-center justify-content-xl-start justify-content-lg-start justify-content-md-start justify-content-start align-items-stretch g-4 ${
                          filterApplied ? "row-cols-xxl-8 row-cols-7"  : "row-cols-xxl-7 row-cols-7"
                        }`}
                      >
                        {/* select modal */}
                        {/* <div className="filter-select SortbyPricing modalities-input">
                          <InputGroup className="input-group">
                            {categoryIcon ? <i className="ri-list-check"></i> : ""}
                            <Select
                              className="w-100 SortbyPricingSelect"
                              name="modalities"
                              id="modalities"
                              instanceId={"modalities"}
                              isMulti
                              isSearchable={screenSize > 991 ? true : searchBar}
                              onMenuClose={() => {
                                setSearchBar(!searchBar);
                                setCategoryIcon(true);
                              }}
                              value={filters.modalities}
                              options={modalities}
                              onInputChange={() => setCategoryIcon(false)}
                              onChange={(value) => {
                                dispatch(
                                  setFilter({ ...filters, modalities: value })
                                );
                              }}
                              placeholder={"Modalities"}
                            />
                          </InputGroup>
                        </div> */}
                        {/* <div className="filter-select SortbyPricing modalities-input">
                          <InputGroup className="filter-select-group symptomsinput-field">
                            <span className="input-group-icon">
                              <i className="ri-mist-line"></i>
                            </span>
                            <Form.Control
                              className="w-100 CitySelectInput"
                              type="text"
                              name="symptoms"
                              placeholder="Symptoms"
                              value={filters.symptoms}
                              onInput={(e) =>
                                dispatch(
                                  setFilter({
                                    ...filters,
                                    symptoms: e.target.value,
                                  })
                                )
                              }
                            />
                          </InputGroup>
                        </div> */}
                         {/* <div className="filter-select SortbyPricing ratinginput free-call-filter col">
                          <Dropdown className="input-group">
                            <Dropdown.Toggle
                              className="new-dropdown-btn"
                              id="dropdown-basic"
                              onClickCapture={() => {
                                setCancelBtn("rating");
                              }}
                            >
                              <i className="ri-exchange-dollar-line dollar"></i>
                              <span>
                                Healers Offering Free Intro Calls
                              </span>{" "}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <div className="dropdown-head">
                                <span>Call Options</span>
                                <Dropdown.Item
                                  className="dropdown-closebtn"
                                  onClick={() => {
                                   
                                    dispatch(
                                      setFilter({
                                        ...filters,
                                        is_free: undefined,
                                      })
                                    );
                                  }}
                                >
                                  <i className="fa fa-times"></i>
                                </Dropdown.Item>
                              </div>

                             
                              <div className="form-check mb-2">
                                <Form.Check
                                  type="radio" 
                                  name="callOption" 
                                  value="freeCall" 
                                  onChange={() => {
                                    dispatch(
                                      setFilter({ ...filters, is_free: true })
                                    ); 
                                  }}
                                  checked={filters.is_free === true} 
                                  id="freeCall"
                                />
                                <Form.Label
                                  className="form-check-label"
                                  htmlFor="freeCall"
                                >
                                  Free Call
                                </Form.Label>
                              </div>

                              
                              <div className="form-check mb-2">
                                <Form.Check
                                  type="radio" 
                                  name="callOption" 
                                  value="paidCall"
                                  onChange={() => {
                                    dispatch(
                                      setFilter({ ...filters, is_free: false })
                                    ); 
                                  }}
                                  checked={filters.is_free === false} 
                                  id="paidCall"
                                />
                                <Form.Label
                                  className="form-check-label"
                                  htmlFor="paidCall"
                                >
                                  Paid Call
                                </Form.Label>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>  */}
                        
                          <div className="filter-select SortbyPricing ratinginput free-call-filter col">   
                          <div className="input-group">
                            <button type="button"
                            className={`new-dropdown-btn free-intro-btn ${filters.is_free === true ? "active" :""}`}
                              onClick={()=>{
                               dispatch(setFilter({...filters,is_free : true}));
                                 }}
                                >
                                 Free Intro Calls
                             </button>
                          </div>
                              </div > 
                      
                        
                        <Modalityfilter
                          props={{
                            modalities,
                          }}
                        />
                        <Symptomsfilter
                          props={{
                            symptoms,
                          }}
                        />
                        {/* location */}
                        <Dropdown className="input-group locationinput col">
                          <Dropdown.Toggle
                            className={
                              filters?.state
                                ? "new-dropdown-btn active"
                                : "new-dropdown-btn"
                            }
                            id="dropdown-basic"
                            onClickCapture={() => {
                              setCancelBtn("location");
                            }}
                          >
                            <i className="ri-map-pin-line"></i>Location
                          </Dropdown.Toggle>

                          <Dropdown.Menu
                          // style={
                          //   cancelBtn == "location"
                          //     ? { display: "block" }
                          //     : { display: "none" }
                          // }
                          >
                            <div className="dropdown-head">
                              <span>Select Location</span>
                              <Dropdown.Item className="dropdown-closebtn">
                                <i className="fa fa-times"></i>
                              </Dropdown.Item>
                            </div>
                            <Select
                              className="w-100 locationSelect"
                              name="state"
                              id="state"
                              instanceId={"state"}
                              isSearchable={screenSize > 991 ? true : searchBar}
                              onMenuClose={() => {
                                setSearchBar(!searchBar);
                              }}
                              value={filters.state}
                              options={states}
                              onChange={(value) =>
                                dispatch(
                                  setFilter({ ...filters, state: value })
                                )
                              }
                              placeholder={"Select State"}
                            />
                            <Form.Control
                              className="w-100 CitySelectInput mt-2"
                              type="text"
                              name="city"
                              placeholder="Enter city here..."
                              value={filters.city}
                              onInput={(e) =>
                                dispatch(
                                  setFilter({
                                    ...filters,
                                    city: e.target.value,
                                  })
                                )
                              }
                            />
                            {/* <Dropdown.Item
                              className="theme-btn mt-3"                              
                            >
                              Apply
                            </Dropdown.Item> */}
                          </Dropdown.Menu>
                        </Dropdown>
                        {/* session */}
                        <Dropdown className="input-group col">
                          <Dropdown.Toggle
                            className={
                              filters?.bookingTypes?.length
                                ? "new-dropdown-btn active"
                                : "new-dropdown-btn"
                            }
                            id="dropdown-basic"
                            onClickCapture={() => {
                              setCancelBtn("session");
                            }}
                          >
                            <i className="ri-map-pin-time-line"></i>
                            Session Type
                          </Dropdown.Toggle>

                          <Dropdown.Menu
                          // style={
                          //   cancelBtn == "session"
                          //     ? { display: "block" }
                          //     : { display: "none" }
                          // }
                          >
                            <div className="dropdown-head">
                              <span>Select Session</span>
                              <Dropdown.Item className="dropdown-closebtn">
                                <i className="fa fa-times"></i>
                              </Dropdown.Item>
                            </div>
                            {bookingTypes?.map((type, index) => (
                              <div className="form-check d-flex" key={index}>
                                <Form.Check
                                  onChange={(e) => {
                                    onChangeBookingType(e);
                                  }}
                                  type="radio"
                                  name="booking-type"
                                  value={type.id}
                                  checked={filters?.bookingTypes.some(
                                    (item) => item == type.id
                                  )}
                                  id={"booking-type-" + index}
                                />
                                <Form.Label
                                  className="form-check-label"
                                  for={"booking-type-" + index}
                                >
                                  {type.name}
                                </Form.Label>
                              </div>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                        {/* rating */}
                        <div className="filter-select SortbyPricing ratinginput col d-md-block d-none">
                          <Dropdown className="input-group">
                            <Dropdown.Toggle
                              className={
                                filters?.ratings?.length
                                  ? "new-dropdown-btn active"
                                  : "new-dropdown-btn"
                              }
                              id="dropdown-basic"
                              onClickCapture={() => {
                                setCancelBtn("rating");
                              }}
                            >
                              <i className="ri-star-line"></i>Rating{" "}
                              {filters?.ratings?.length
                                ? `(${filters?.ratings?.length})`
                                : ""}
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                            // style={
                            //   cancelBtn == "rating"
                            //     ? { display: "block" }
                            //     : { display: "none" }
                            // }
                            >
                              <div className="dropdown-head">
                                <span>Select Rating</span>
                                <Dropdown.Item className="dropdown-closebtn">
                                  <i className="fa fa-times"></i>
                                </Dropdown.Item>
                              </div>

                              {[...Array(5).keys()].reverse().map((e, i) => (
                                <>
                                  <div className="form-check mb-2" key={i}>
                                    <Form.Check
                                      type="checkbox"
                                      name="rating"
                                      value={e + 1}
                                      onChange={(el) => {
                                        onChangeRatings(el);
                                      }}
                                      checked={filters.ratings.includes(
                                        (e + 1).toString()
                                      )}
                                      id={`rating-${e + 1}`}
                                    />
                                    <Form.Label
                                      className="form-check-label"
                                      htmlFor={`rating-${e + 1}`}
                                    >
                                      <span>
                                        {[...Array(5).keys()]
                                          .reverse()
                                          .map((f, j) => (
                                            <>
                                              <i
                                                key={j}
                                                className={`ri-star-fill ${
                                                  e + 1 >= f + 1
                                                    ? "star-fill"
                                                    : ""
                                                }`}
                                              ></i>
                                            </>
                                          ))}
                                      </span>
                                    </Form.Label>
                                  </div>
                                </>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>

                        {/* price */}
                        <div className="MobileFillterOpstion col">
                          
                            <div className="filter-select SortbyPricing sortby-input modalities-input">
                              {screenSize > 717 ? (
                                <InputGroup
                                  className={
                                    filters.sorting == ""
                                      ? "input-group"
                                      : "input-group active"
                                  }
                                >
                                  {/* <Form.Label>Sort By</Form.Label> */}
                                  <i className="ri-menu-2-line"></i>
                                  <Select
                                    className={
                                      filters.sorting == ""
                                        ? "w-100 SortbyPricingSelect"
                                        : "w-100 SortbyPricingSelect active"
                                    }
                                    name="extra"
                                    styles={customStyles}
                                    id="extra"
                                    instanceId={"extra"}
                                    isSearchable={false}
                                    value={
                                      filters.sorting == "asc"
                                        ? {
                                            label: "Price: Low to High",
                                            value: "asc",
                                          }
                                        : filters.sorting == "desc"
                                        ? {
                                            label: "Price: High to Low",
                                            value: "desc",
                                          }
                                        : ""
                                    }
                                    options={[
                                      {
                                        label: "Price: Low to High",
                                        value: "asc",
                                      },
                                      {
                                        label: "Price: High to Low",
                                        value: "desc",
                                      },
                                    ]}
                                    onChange={(value) =>
                                      dispatch(
                                        setFilter({
                                          ...filters,
                                          sorting: value.value,
                                        })
                                      )
                                    }
                                    placeholder={"Sort By"}
                                  />
                                </InputGroup>
                              ) : (
                                <InputGroup className="input-group">
                                  <i className="ri-sort-asc"></i>
                                  <Form.Select
                                    className="w-100 SortbyPricingSelect"
                                    name="extra"
                                    id="extra"
                                    value={filters.sorting}
                                    onChange={(value) => {
                                      dispatch(
                                        setFilter({
                                          ...filters,
                                          sorting: value.target.value,
                                        })
                                      );
                                    }}
                                    placeholder={"Select Option"}
                                  >
                                    <option value="">Sort By</option>
                                    <option value="asc">
                                      Price: Low to High
                                    </option>
                                    <option value="desc">
                                      Price: High to Low
                                    </option>
                                  </Form.Select>
                                  {/* ^^^^ Replace this code for this -->>>>>> */}
                                  {/* <Form.Select
                                    className="w-100 SortbyPricingSelect"
                                    name="extra"
                                    id="extra"
                                    placeholder={"Select Option"}
                                    >
                                      <option selected="selected"> What's New </option>
                                      <option value="asc">Price: Low to High</option>
                                      <option value="desc">Price: High to Low</option>
                                  </Form.Select> */}
                                </InputGroup>
                              )}
                            </div>
                            <div
                              className="mobilefilter-box "
                              onClick={() => setshowfilter(true)}
                            >
                              <div
                                className="mobilefilter-button"
                                onClick={() => setshowfilter(false)}
                              >
                                <i className="fa-solid fa-sliders"></i>
                                <span className="m-filter-labal">filter</span>
                              </div>
                            </div>
                            {/* close */}
                            {/* {filterApplied ? (
                              <Button
                                type="button"
                                className="theme-btn clearall-filter"
                                onClick={() => {
                                  clearFilter();
                                  dispatch(set_Selected_languages([]));
                                  dispatch(set_Selected_languages_symp([]));
                                }}
                              >
                                Clear <i className="fa fa-times"></i>
                              </Button>
                            ) : (
                              ""
                            )} */}
                          
                        </div>
                        {filterApplied && screenSize > 717 ? (
                          <Col className="col">
                            <Button
                              type="button"
                              className="theme-btn clearall-filter filter-clear-btn clearbtn-desktop"
                              onClick={() => {
                                clearFilter();
                                dispatch(set_Selected_languages([]));
                                dispatch(set_Selected_languages_symp([]));
                              }}
                            >
                              Clear{" "}
                              <div className="icon">
                                <i className="fa fa-times"></i>
                              </div>
                            </Button>
                          </Col>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                    {/* <Col className="d-flex flex-row-reverse">
                      {filterApplied && screenSize > 717 ? (
                        <Button
                          type="button"
                          className="theme-btn clearall-filter filter-clear-btn mt-2"
                          onClick={() => {
                            clearFilter();
                            dispatch(set_Selected_languages([]));
                            dispatch(set_Selected_languages_symp([]));
                          }}
                        >
                          Clear <i className="fa fa-times"></i>
                        </Button>
                      ) : (
                        ""
                      )}
                    </Col> */}
                  </Row>
                  <InfiniteScroll
                    dataLength={healers.length}
                    next={() => fetchHealers(true)}
                    hasMore={hasMore}
                    loader={
                      <div className="text-center mt-5">
                        <Spinner animation="border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </Spinner>
                      </div>
                    }
                    // endMessage={
                    //   <div className="text-center mt-5">
                    //     <span className="text-center">
                    //       All the healers are listed!
                    //     </span>
                    //   </div>
                    // }
                    style={{ overflow: "hidden" }}
                  >
                    <Row className="row-cols-lg-5 row-cols-md-3 row-cols-2">
                      {healers.map((item, index) => {
                        return (
                          <Col className="mb-3" key={index}>
                            <div className={styles["doctor-card"]}>
                              <div className={styles["doctor-image"]}>
                                <Link
                                  href={`/healers/${item.slug}/detail`}
                                  // className={styles["theme-btn"]}
                                >
                                  <Image
                                    src={item.image ?? dummyHealerImage}
                                    height={328}
                                    width={320}
                                    alt="Healer Image"
                                  />
                                </Link>
                              </div>
                              <div className={styles["doctor-content"]}>
                                <div className={styles["doctor-name"]}>
                                  <Link
                                    href={`/healers/${item.slug}/detail`}
                                    //className={styles["theme-btn"]}
                                  >
                                    <h4>{item.name}</h4>
                                  </Link>

                                  <i className="ri-checkbox-circle-fill"></i>
                                </div>
                                <h6>{item.profile_tag ?? "Not Specified"}</h6>
                                <div className={styles["feedback"]}>
                                  <span>
                                    {[...Array(5).keys()].map((i, j) => (
                                      <>
                                        <i
                                          key={j}
                                          className={`ri-star-fill ${
                                            i + 1 <= item.rating
                                              ? "star-fill"
                                              : ""
                                          }`}
                                        ></i>
                                      </>
                                    ))}
                                  </span>
                                  <p>{item.feedback ?? 0} Feedback</p>
                                </div>
                                <div className={styles["doctor-info"]}>
                                  <ul>
                                    <li>
                                      <i className="ri-calendar-line"></i>{" "}
                                      {item.experience && item.experience != ""
                                        ? item.experience > 1
                                          ? item.experience + " Years"
                                          : item.experience + " Year"
                                        : "0 Year"}
                                    </li>
                                    <li>
                                      <i className="ri-map-pin-line"></i>{" "}
                                      {(item.state ? item.state : "-") +
                                        (item.country
                                          ? ", " + item.country
                                          : "-")}
                                    </li>
                                    <li>
                                      <i className="ri-user-3-line"></i>{" "}
                                      {item.sessions && item.sessions != ""
                                        ? item.sessions
                                        : "Not Specified"}
                                    </li>
                                    {item?.free_call == 1 ? (
                                      <li>
                                        <i className="ri-customer-service-line"></i>{" "}
                                        Free & Paid Call Available
                                      </li>
                                    ) : (
                                      <li>
                                        <i className="ri-customer-service-line"></i>{" "}
                                        Paid Call Available
                                      </li>
                                    )}
                                  </ul>
                                </div>
                                <Link
                                  href={`/healers/${item.slug}/slots`}
                                  className={styles["theme-btn"]}
                                >
                                  Book Now{" "}
                                  <i className="ri-arrow-right-line"></i>
                                </Link>
                              </div>
                            </div>
                          </Col>
                        );
                      })}
                    </Row>
                  </InfiniteScroll>
                </div>
              </Row>
            </Container>
          </section>
        )}
      </>
      <Link
        id="floatingBook"
        className="floating-book"
        aria-label="Book a FREE call now"
        href="/healers"
        style={{ opacity: showSideButton ? 1 : 0 }}
      >
        Book a FREE call now
      </Link>
    </>
  );
};

HealerListing.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};

export default HealerListing;

// ssr
export async function getServerSideProps() {
  const fetchStates = async () => {
    const res = await healerServices.getStates(231);
    if (res.status) {
      return res.data.map((i) => ({ value: i.id, label: i.name }));
    } else {
      toast.error(res.message, {
        autoClose: 5000,
      });
    }
  };

  const fetchBookingTypes = async () => {
    const res = await healerServices.getTypesOfSessions();
    if (res.status) {
      return res.data;
    } else {
      toast.error(res.message, {
        autoClose: 5000,
      });
    }
  };

  const fetchModalitiesSearch = async () => {
    const res = await healerServices.getModalitiesSearch();
    if (res.status) {
      return res.data.data.map((i) => ({ value: i.id, label: i.name }));
    } else {
      toast.error(res.message, {
        autoClose: 5000,
      });
    }
  };

  const fetchSymptomsSearch = async () => {
    const res = await healerServices.getSymptomsSearch();
    if (res.status) {
      return res.data.data.map((i) => ({ value: i.id, label: i.name }));
    } else {
      toast.error(res.message, {
        autoClose: 5000,
      });
    }
  };

  const fetchHealersMeta = async () => {
    try {
      const res = await healerServices.getMetaInformation("healers");
      if (res.status) {
        return res.data;
      }
    } catch (error) {
      console.error("Error fetching slider data:", error);
    }
  };

  const states = (await fetchStates()) ?? {};
  const bookingTypes = (await fetchBookingTypes()) ?? {};
  const modalities = (await fetchModalitiesSearch()) ?? {};
  const symptoms = (await fetchSymptomsSearch()) ?? {};
  const healersMeta = (await fetchHealersMeta()) ?? {};

  // Pass data to the page via props
  return { props: { states, modalities, bookingTypes, healersMeta, symptoms } };
}
